define('modules/ad_form/ad_form_model',['backbone',
  '_',
  'session',

  './ad_form_sub_model'
], function (Backbone, _, session,
             AdFormSubModel) {
  'use strict';
  var Model = Backbone.Model.extend({
    parse: function (response, options) {

      response.htmladModel = response.htmlad_multiple_sections ? new AdFormSubModel(response.htmlad_multiple_sections) : new AdFormSubModel(response.htmlad);
      response.bookingModel = new AdFormSubModel(response.booking);

      if (response.htmlad_multiple_sections) {
        response.htmladModel.set('hasMultipleSections', true);
      }

      return response;
    },

    url: function () {
      var url = session.get('apiUrl') + 'htmladlocation/';

      if (this.has('is_campaign') && this.get('is_campaign')) {
        url = session.get('apiUrl') + 'campaigns/';
      }

      if (this.has('id')) {
        url +=  + this.get('id');
      } else { // The following will only be invoked when making normal HtmlAds (never for campaigns)
        url += 'new?location_id=' + session.get('location_id');
        if (this.has('zone_id')) {
          url += '&zone_id=' + this.get('zone_id');
        }
        if (this.has('template_id')) {
          url += '&template_id=' + this.get('template_id');
				}
				if (this.has('player_id')) {
          url += '&player_id=' + this.get('player_id');
        }
      }
      return url;
    }
  });

  return Model;
});

